import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { REPORTING_API_REQUEST } from 'ag-common-svc/public-api';
import { Observable } from 'rxjs';
import { ReportingApiRequestContextService } from 'src/app/alliance-group/core/services/reporting-api-request-context.service';

@Injectable()
export class ReportingApiImpersonationInterceptor implements HttpInterceptor {
  constructor(private readonly reportingApiRequestContextService: ReportingApiRequestContextService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!request.context.get(REPORTING_API_REQUEST)) {
      return next.handle(request);
    }

    const { loggedInAgentDbId, viewedAgentDbId } = this.reportingApiRequestContextService.getContext();
    if (!loggedInAgentDbId || !viewedAgentDbId || loggedInAgentDbId === viewedAgentDbId) {
      return next.handle(request);
    }

    return next.handle(
      request.clone({
        setHeaders: {
          'X-Impersonate-Agent-DbId': viewedAgentDbId,
        },
      }),
    );
  }
}
